import { clamp } from "lodash-es";

import PlaybackTimeline from "../types/PlaybackTimeline";

// The single progress (0..1) -> epoch time mapping. The virtual-time selector, the engine's
// crossing check and both readouts all route through here, so the rail, the revealed pins and the
// displayed time can never drift apart. Replaces the copies that used to live in each of them.
const getTimelineTimeMs = (timeline: PlaybackTimeline, progress: number): number =>
  timeline.startMs + clamp(progress, 0, 1) * (timeline.endMs - timeline.startMs);

export default getTimelineTimeMs;
